import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormControl as BaseFormControl, Box, HStack } from "native-base";
import { useCallback, useEffect, useMemo, useRef } from "react";
import { formatTime } from "@madmedical/utils";
import DateInput from "./DateInput";
import Input from "./Input";
const DateTimeInput = ({ value, onChange, label, isRequired = false, isInvalid = false, error, }) => {
    const timeInputRef = useRef(null);
    const dateValue = useMemo(() => (value ? new Date(value) : new Date()), [value]);
    const handleDateChange = useCallback((newValue) => {
        onChange(new Date(newValue.getFullYear(), newValue.getMonth(), newValue.getDate(), dateValue.getHours(), dateValue.getMinutes(), 0, 0).toISOString());
    }, [dateValue, onChange]);
    const handleTimeChange = useCallback((newValue) => {
        const hours = parseInt(newValue.slice(0, 2), 10);
        const minutes = parseInt(newValue.slice(3, 5), 10);
        onChange(new Date(dateValue.getFullYear(), dateValue.getMonth(), dateValue.getDate(), hours, minutes, 0, 0).toISOString());
    }, [dateValue, onChange]);
    useEffect(() => {
        const timeInput = timeInputRef.current;
        if (!timeInput) {
            return;
        }
        timeInput.setNativeProps({
            type: "time",
            pattern: "d{2}:d{2}",
        });
    }, []);
    return (_jsxs(BaseFormControl, Object.assign({ flex: 1, isInvalid: isInvalid, isRequired: isRequired }, { children: [label && (_jsx(BaseFormControl.Label, Object.assign({ fontWeight: "medium", isRequired: isRequired, _text: {
                    color: "gray.600",
                } }, { children: label }))), _jsxs(HStack, Object.assign({ space: 2 }, { children: [_jsx(Box, Object.assign({ flex: "1" }, { children: _jsx(DateInput, { isInvalid: isInvalid, value: dateValue, onChange: handleDateChange }) })), _jsx(Box, Object.assign({ flex: "1" }, { children: _jsx(Input, { ref: timeInputRef, value: formatTime(dateValue), onChange: handleTimeChange, size: "md", isInvalid: isInvalid }) }))] })), error && (_jsx(BaseFormControl.ErrorMessage, Object.assign({ mt: 1, _text: { fontSize: "sm" } }, { children: error })))] })));
};
export default DateTimeInput;
